import React, { useState } from 'react';

const ContributionToggleDetails = ({ title, paragraphs }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mb-4">
      {/* Button with blue color but white text for title */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-start text-left w-full"
      >
        {/* Icon with circle that doesn't get squished */}
        <div className="flex-shrink-0 mt-1 mr-4">
          <div className="flex items-center justify-center w-5 h-5 rounded-full border border-[#2978C8] dark:border-[#4f9cf9]">
            <svg
              className={`w-3 h-3 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="#2978C8"
              strokeWidth="3"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
        
        {/* Title text that's white/dark in dark/light mode */}
        <span className="text-xl text-[#222222] dark:text-white">
          {title}
        </span>
      </button>

      {/* Content that appears when expanded - with smooth animation */}
      <div 
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="mt-2 pl-7 border-l-2 border-[#2978C8] dark:border-[#4f9cf9] text-[#333333] dark:text-[#e0e0e0]">
          {paragraphs.map((paragraph, index) => (
            <p key={index} className="mb-2 text-base">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContributionToggleDetails; 